import { buildIntrinsicWidthSources } from '@velasca/utils/build-intrinsic-width-sources'
import { setQueryParams } from '@velasca/utils/set-query-params'
import { SansText } from '../SansText/SansText'
import { SansTitle } from '../SansTitle/SansTitle'
import { BackgroundImage, BlockContainer, Card } from './ImageCard.styles'
import type { ImageCardProps } from './ImageCard.types'

export const ImageCard = ({
  image,
  title,
  urlText,
  url,
}: ImageCardProps): JSX.Element => {
  return (
    <Card href={url}>
      {image && (
        <BackgroundImage
          lqip
          lazyload
          alt={image.alt}
          imgSrc={setQueryParams(image.src, [{ name: 'width', value: '30' }])}
          sources={buildIntrinsicWidthSources({
            src: image.src,
          })}
        />
      )}
      <BlockContainer>
        {title && (
          <SansTitle tracking="wide" as="h3" color="white" fontWeight="500">
            {title}
          </SansTitle>
        )}

        {urlText && (
          <SansText
            as="span"
            dangerouslySetInnerHTML={{ __html: urlText }}
            color="white"
            size="xl"
          />
        )}
      </BlockContainer>
    </Card>
  )
}
